/**
 * @generated SignedSource<<6c641fb6f1923fa3fce08463bb33d741>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CartNav_viewer" | "Likes_viewer" | "Notifications_viewer" | "Notifications_initialViewer" | "SearchBar_viewer">;
  readonly " $fragmentType": "TopBar_viewer";
};
export type TopBar_viewer$key = {
  readonly " $data"?: TopBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasSessionCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CartNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Likes_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "hasSessionCountryCode",
          "variableName": "hasSessionCountryCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Notifications_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Notifications_initialViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SearchBar_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "245c0d77f3d1516476adf2a9fcb3a1f5";

export default node;
